'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var Reader = require('it-reader');

var log = require('debug')('it-multistream-select:ls');

var multistream = require('./multistream');

var handshake = require('it-handshake');

var lp = require('it-length-prefixed');

var pipe = require('it-pipe');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var _handshake, reader, writer, rest, shakeStream, res, protocolsReader, protocols;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _handshake = handshake(stream), reader = _handshake.reader, writer = _handshake.writer, rest = _handshake.rest, shakeStream = _handshake.stream;
            log('write "ls"');
            multistream.write(writer, 'ls');
            rest(); // Next message from remote will be (e.g. for 2 protocols):
            // <varint-msg-len><varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n

            _context2.next = 6;
            return multistream.read(reader);

          case 6:
            res = _context2.sent;
            // After reading response we have:
            // <varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n
            protocolsReader = Reader([res]);
            protocols = []; // Decode each of the protocols from the reader

            _context2.next = 11;
            return pipe(protocolsReader, lp.decode(), /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, protocol;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _context.prev = 2;
                        _iterator = _asyncIterator(source);

                      case 4:
                        _context.next = 6;
                        return _iterator.next();

                      case 6:
                        _step = _context.sent;
                        _iteratorNormalCompletion = _step.done;
                        _context.next = 10;
                        return _step.value;

                      case 10:
                        _value = _context.sent;

                        if (_iteratorNormalCompletion) {
                          _context.next = 17;
                          break;
                        }

                        protocol = _value;
                        // Remove the newline
                        protocols.push(protocol.shallowSlice(0, -1).toString());

                      case 14:
                        _iteratorNormalCompletion = true;
                        _context.next = 4;
                        break;

                      case 17:
                        _context.next = 23;
                        break;

                      case 19:
                        _context.prev = 19;
                        _context.t0 = _context["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _context.t0;

                      case 23:
                        _context.prev = 23;
                        _context.prev = 24;

                        if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                          _context.next = 28;
                          break;
                        }

                        _context.next = 28;
                        return _iterator.return();

                      case 28:
                        _context.prev = 28;

                        if (!_didIteratorError) {
                          _context.next = 31;
                          break;
                        }

                        throw _iteratorError;

                      case 31:
                        return _context.finish(28);

                      case 32:
                        return _context.finish(23);

                      case 33:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 19, 23, 33], [24,, 28, 32]]);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 11:
            return _context2.abrupt("return", {
              stream: shakeStream,
              protocols: protocols
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();